module.exports = __webpack_public_path__ + "static/media/ffigueras3.ec2aea1f.jpg";